/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_YogaInputs */

const en_service_type_yoga = /** @type {(inputs: Service_Type_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const pl_service_type_yoga = /** @type {(inputs: Service_Type_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joga`)
};

/**
* | output |
* | --- |
* | "Yoga" |
*
* @param {Service_Type_YogaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_yoga = /** @type {((inputs?: Service_Type_YogaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_YogaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_yoga(inputs)
	return en_service_type_yoga(inputs)
});